/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const userStats = /* GraphQL */ `query UserStats($userId: String) {
  userStats(userId: $userId) {
    percentCompleted
    averageResponseTime
    assessmentsCreated
    assessmentsCompleted
    assessmentsExpired
    __typename
  }
}
` as GeneratedQuery<APITypes.UserStatsQueryVariables, APITypes.UserStatsQuery>;
export const siblingUsers = /* GraphQL */ `query SiblingUsers($userId: String) {
  siblingUsers(userId: $userId) {
    id
    email
    emailLower
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    cognitoUsername
    firstName
    lastName
    suffix
    npi
    simplLearnId
    pgy
    settings {
      sendEmail
      sendPushNotifications
      __typename
    }
    lastLogin
    eulaAcceptedDate
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deviceToken
    devicePlatform
    inviteId
    invite {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    jobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SiblingUsersQueryVariables,
  APITypes.SiblingUsersQuery
>;
export const paginatableSiblingUsers = /* GraphQL */ `query PaginatableSiblingUsers($input: PaginatableSiblingUsersArgs) {
  paginatableSiblingUsers(input: $input) {
    nextToken
    total
    items {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaginatableSiblingUsersQueryVariables,
  APITypes.PaginatableSiblingUsersQuery
>;
export const completedAssessmentHistoryByProgramMembership = /* GraphQL */ `query CompletedAssessmentHistoryByProgramMembership(
  $programMembershipId: String
) {
  completedAssessmentHistoryByProgramMembership(
    programMembershipId: $programMembershipId
  ) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CompletedAssessmentHistoryByProgramMembershipQueryVariables,
  APITypes.CompletedAssessmentHistoryByProgramMembershipQuery
>;
export const assessmentHistory = /* GraphQL */ `query AssessmentHistory($input: AssessmentHistoryArgs) {
  assessmentHistory(input: $input) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssessmentHistoryQueryVariables,
  APITypes.AssessmentHistoryQuery
>;
export const paginatableAssessmentHistory = /* GraphQL */ `query PaginatableAssessmentHistory($input: PaginatableAssessmentHistoryArgs) {
  paginatableAssessmentHistory(input: $input) {
    nextToken
    total
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaginatableAssessmentHistoryQueryVariables,
  APITypes.PaginatableAssessmentHistoryQuery
>;
export const milestoneReport = /* GraphQL */ `query MilestoneReport($programMembershipIds: [String]) {
  milestoneReport(programMembershipIds: $programMembershipIds)
}
` as GeneratedQuery<
  APITypes.MilestoneReportQueryVariables,
  APITypes.MilestoneReportQuery
>;
export const updateUserEmail = /* GraphQL */ `query UpdateUserEmail($input: UpdateUserEmailArgs) {
  updateUserEmail(input: $input)
}
` as GeneratedQuery<
  APITypes.UpdateUserEmailQueryVariables,
  APITypes.UpdateUserEmailQuery
>;
export const engagementReport = /* GraphQL */ `query EngagementReport($input: EngagementReportArgs) {
  engagementReport(input: $input) {
    success
    error
    programReportRows {
      institutionId
      institutionName
      programId
      program
      createdAssessmentEvents
      assignedAssessmentEvents
      completedAssessmentEvents
      percentCompleted
      attendingsInProgram
      traineesInProgram
      averageCompletedPerTrainee
      __typename
    }
    userReportRows {
      userId
      firstName
      lastName
      email
      programRole
      programId
      program
      createdAssessmentEvents
      assignedAssessmentEvents
      completedAssessmentEvents
      percentCompleted
      expiredAssessmentEvents
      percentExpired
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EngagementReportQueryVariables,
  APITypes.EngagementReportQuery
>;
export const validateBulkUpload = /* GraphQL */ `query ValidateBulkUpload($input: ValidateBulkUploadArgs) {
  validateBulkUpload(input: $input) {
    success
    error
    invitations {
      requestId
      firstName
      lastName
      email
      role
      programId
      npi
      simplLearnId
      pgy
      traineeType
      jobTitle
      errors {
        field
        error
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidateBulkUploadQueryVariables,
  APITypes.ValidateBulkUploadQuery
>;
export const requestBulkCCCReport = /* GraphQL */ `query RequestBulkCCCReport($input: RequestBulkCCCReportInput) {
  requestBulkCCCReport(input: $input)
}
` as GeneratedQuery<
  APITypes.RequestBulkCCCReportQueryVariables,
  APITypes.RequestBulkCCCReportQuery
>;
export const sendUserInvitation = /* GraphQL */ `query SendUserInvitation($input: SendUserInvitationArgs) {
  sendUserInvitation(input: $input) {
    success
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SendUserInvitationQueryVariables,
  APITypes.SendUserInvitationQuery
>;
export const availableActivities = /* GraphQL */ `query AvailableActivities($input: AvailableActivitiesArgs) {
  availableActivities(input: $input) {
    activities {
      id
      title
      description
      assessmentId
      sponsor {
        id
        name
        description
        activityLabel
        branding {
          __typename
        }
        createdAt
        updatedAt
        deletedAt
        __typename
      }
      categories
      programIds
      __typename
    }
    total
    nextPage
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AvailableActivitiesQueryVariables,
  APITypes.AvailableActivitiesQuery
>;
export const activitiesByUsers = /* GraphQL */ `query ActivitiesByUsers($input: ActivitiesByUsersArgs) {
  activitiesByUsers(input: $input) {
    error
    activities {
      id
      title
      description
      assessmentId
      sponsor {
        id
        name
        description
        activityLabel
        branding {
          __typename
        }
        createdAt
        updatedAt
        deletedAt
        __typename
      }
      categories
      programIds
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActivitiesByUsersQueryVariables,
  APITypes.ActivitiesByUsersQuery
>;
export const paginatableActivitiesByUsers = /* GraphQL */ `query PaginatableActivitiesByUsers($input: PaginatableActivitiesByUsersArgs) {
  paginatableActivitiesByUsers(input: $input) {
    activities {
      id
      title
      description
      assessmentId
      sponsor {
        id
        name
        description
        activityLabel
        branding {
          __typename
        }
        createdAt
        updatedAt
        deletedAt
        __typename
      }
      categories
      programIds
      __typename
    }
    total
    nextPage
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaginatableActivitiesByUsersQueryVariables,
  APITypes.PaginatableActivitiesByUsersQuery
>;
export const usersPendingAssessments = /* GraphQL */ `query UsersPendingAssessments($userId: String) {
  usersPendingAssessments(userId: $userId) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersPendingAssessmentsQueryVariables,
  APITypes.UsersPendingAssessmentsQuery
>;
export const paginatableUsersPendingAssessments = /* GraphQL */ `query PaginatableUsersPendingAssessments(
  $input: PaginatableUsersPendingAssessmentsArgs
) {
  paginatableUsersPendingAssessments(input: $input) {
    nextToken
    total
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaginatableUsersPendingAssessmentsQueryVariables,
  APITypes.PaginatableUsersPendingAssessmentsQuery
>;
export const networkRatingRules = /* GraphQL */ `query NetworkRatingRules($userId: String) {
  networkRatingRules(userId: $userId) {
    showPrompt
    assessmentRole
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NetworkRatingRulesQueryVariables,
  APITypes.NetworkRatingRulesQuery
>;
export const paginatableAssessmentHistorySearchUser = /* GraphQL */ `query PaginatableAssessmentHistorySearchUser(
  $input: AssessmentHistorySearchUserArgs
) {
  paginatableAssessmentHistorySearchUser(input: $input) {
    nextToken
    total
    items {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaginatableAssessmentHistorySearchUserQueryVariables,
  APITypes.PaginatableAssessmentHistorySearchUserQuery
>;
export const getInstitution = /* GraphQL */ `query GetInstitution($id: ID!) {
  getInstitution(id: $id) {
    id
    name
    description
    programs {
      items {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    users {
      items {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInstitutionQueryVariables,
  APITypes.GetInstitutionQuery
>;
export const listInstitutions = /* GraphQL */ `query ListInstitutions(
  $filter: ModelInstitutionFilterInput
  $limit: Int
  $nextToken: String
) {
  listInstitutions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInstitutionsQueryVariables,
  APITypes.ListInstitutionsQuery
>;
export const getProgram = /* GraphQL */ `query GetProgram($id: ID!) {
  getProgram(id: $id) {
    id
    name
    description
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sponsors {
      items {
        id
        programID
        sponsorID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    networks {
      items {
        id
        programID
        networkID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProgramQueryVariables,
  APITypes.GetProgramQuery
>;
export const listPrograms = /* GraphQL */ `query ListPrograms(
  $filter: ModelProgramFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrograms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProgramsQueryVariables,
  APITypes.ListProgramsQuery
>;
export const programsByInstitution = /* GraphQL */ `query ProgramsByInstitution(
  $institutionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProgramFilterInput
  $limit: Int
  $nextToken: String
) {
  programsByInstitution(
    institutionId: $institutionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProgramsByInstitutionQueryVariables,
  APITypes.ProgramsByInstitutionQuery
>;
export const searchPrograms = /* GraphQL */ `query SearchPrograms(
  $filter: SearchableProgramFilterInput
  $sort: [SearchableProgramSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableProgramAggregationInput]
) {
  searchPrograms(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchProgramsQueryVariables,
  APITypes.SearchProgramsQuery
>;
export const getNetwork = /* GraphQL */ `query GetNetwork($id: ID!) {
  getNetwork(id: $id) {
    id
    name
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programs {
      items {
        id
        programID
        networkID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activities {
      items {
        id
        networkID
        activityID
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    acgmeEnabled
    allAttendingHistoryDisabled
    simpl1Id
    categoriesExcludedFromRequestFlow
    dashboardURL
    showDashboardLink
    disableClassicReports
    traineeCanRateTrainee
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNetworkQueryVariables,
  APITypes.GetNetworkQuery
>;
export const listNetworks = /* GraphQL */ `query ListNetworks(
  $filter: ModelNetworkFilterInput
  $limit: Int
  $nextToken: String
) {
  listNetworks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNetworksQueryVariables,
  APITypes.ListNetworksQuery
>;
export const networksBySponsor = /* GraphQL */ `query NetworksBySponsor(
  $sponsorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelNetworkFilterInput
  $limit: Int
  $nextToken: String
) {
  networksBySponsor(
    sponsorId: $sponsorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NetworksBySponsorQueryVariables,
  APITypes.NetworksBySponsorQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    email
    emailLower
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    cognitoUsername
    firstName
    lastName
    suffix
    npi
    simplLearnId
    pgy
    settings {
      sendEmail
      sendPushNotifications
      __typename
    }
    lastLogin
    eulaAcceptedDate
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deviceToken
    devicePlatform
    inviteId
    invite {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    jobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const usersByEmail = /* GraphQL */ `query UsersByEmail(
  $email: AWSEmail!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByEmailQueryVariables,
  APITypes.UsersByEmailQuery
>;
export const usersByEmailLower = /* GraphQL */ `query UsersByEmailLower(
  $emailLower: AWSEmail!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByEmailLower(
    emailLower: $emailLower
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByEmailLowerQueryVariables,
  APITypes.UsersByEmailLowerQuery
>;
export const usersByInstitution = /* GraphQL */ `query UsersByInstitution(
  $institutionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByInstitution(
    institutionId: $institutionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByInstitutionQueryVariables,
  APITypes.UsersByInstitutionQuery
>;
export const usersByNPI = /* GraphQL */ `query UsersByNPI(
  $npi: Int!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByNPI(
    npi: $npi
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByNPIQueryVariables,
  APITypes.UsersByNPIQuery
>;
export const searchUsers = /* GraphQL */ `query SearchUsers(
  $filter: SearchableUserFilterInput
  $sort: [SearchableUserSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableUserAggregationInput]
) {
  searchUsers(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchUsersQueryVariables,
  APITypes.SearchUsersQuery
>;
export const getUserInvitation = /* GraphQL */ `query GetUserInvitation($id: ID!) {
  getUserInvitation(id: $id) {
    id
    inviteeId
    invitee {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    institutionId
    invitationStatus
    email
    emailLower
    adminId
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    role
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserInvitationQueryVariables,
  APITypes.GetUserInvitationQuery
>;
export const listUserInvitations = /* GraphQL */ `query ListUserInvitations(
  $filter: ModelUserInvitationFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserInvitations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserInvitationsQueryVariables,
  APITypes.ListUserInvitationsQuery
>;
export const userInvitationsByEmail = /* GraphQL */ `query UserInvitationsByEmail(
  $email: AWSEmail!
  $sortDirection: ModelSortDirection
  $filter: ModelUserInvitationFilterInput
  $limit: Int
  $nextToken: String
) {
  userInvitationsByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserInvitationsByEmailQueryVariables,
  APITypes.UserInvitationsByEmailQuery
>;
export const userInvitationsByEmailLower = /* GraphQL */ `query UserInvitationsByEmailLower(
  $emailLower: AWSEmail!
  $sortDirection: ModelSortDirection
  $filter: ModelUserInvitationFilterInput
  $limit: Int
  $nextToken: String
) {
  userInvitationsByEmailLower(
    emailLower: $emailLower
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserInvitationsByEmailLowerQueryVariables,
  APITypes.UserInvitationsByEmailLowerQuery
>;
export const userInvitationsByProgram = /* GraphQL */ `query UserInvitationsByProgram(
  $programId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserInvitationFilterInput
  $limit: Int
  $nextToken: String
) {
  userInvitationsByProgram(
    programId: $programId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserInvitationsByProgramQueryVariables,
  APITypes.UserInvitationsByProgramQuery
>;
export const searchUserInvitations = /* GraphQL */ `query SearchUserInvitations(
  $filter: SearchableUserInvitationFilterInput
  $sort: [SearchableUserInvitationSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableUserInvitationAggregationInput]
) {
  searchUserInvitations(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchUserInvitationsQueryVariables,
  APITypes.SearchUserInvitationsQuery
>;
export const getProgramMembership = /* GraphQL */ `query GetProgramMembership($id: ID!) {
  getProgramMembership(id: $id) {
    id
    programRole
    traineeType
    programMemberId
    programId
    programMember {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    startDate
    endDate
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProgramMembershipQueryVariables,
  APITypes.GetProgramMembershipQuery
>;
export const listProgramMemberships = /* GraphQL */ `query ListProgramMemberships(
  $filter: ModelProgramMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  listProgramMemberships(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      programRole
      traineeType
      programMemberId
      programId
      programMember {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      startDate
      endDate
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProgramMembershipsQueryVariables,
  APITypes.ListProgramMembershipsQuery
>;
export const programsByUser = /* GraphQL */ `query ProgramsByUser(
  $programMemberId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProgramMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  programsByUser(
    programMemberId: $programMemberId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      programRole
      traineeType
      programMemberId
      programId
      programMember {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      startDate
      endDate
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProgramsByUserQueryVariables,
  APITypes.ProgramsByUserQuery
>;
export const usersByProgram = /* GraphQL */ `query UsersByProgram(
  $programId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProgramMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByProgram(
    programId: $programId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      programRole
      traineeType
      programMemberId
      programId
      programMember {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      startDate
      endDate
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByProgramQueryVariables,
  APITypes.UsersByProgramQuery
>;
export const searchProgramMemberships = /* GraphQL */ `query SearchProgramMemberships(
  $filter: SearchableProgramMembershipFilterInput
  $sort: [SearchableProgramMembershipSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableProgramMembershipAggregationInput]
) {
  searchProgramMemberships(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      programRole
      traineeType
      programMemberId
      programId
      programMember {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      startDate
      endDate
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchProgramMembershipsQueryVariables,
  APITypes.SearchProgramMembershipsQuery
>;
export const getEULAText = /* GraphQL */ `query GetEULAText($id: ID!) {
  getEULAText(id: $id) {
    id
    formattedText
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEULATextQueryVariables,
  APITypes.GetEULATextQuery
>;
export const listEULATexts = /* GraphQL */ `query ListEULATexts(
  $filter: ModelEULATextFilterInput
  $limit: Int
  $nextToken: String
) {
  listEULATexts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      formattedText
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEULATextsQueryVariables,
  APITypes.ListEULATextsQuery
>;
export const getMilestone = /* GraphQL */ `query GetMilestone($id: ID!) {
  getMilestone(id: $id) {
    id
    shortName
    name
    description
    scale
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMilestoneQueryVariables,
  APITypes.GetMilestoneQuery
>;
export const listMilestones = /* GraphQL */ `query ListMilestones(
  $filter: ModelMilestoneFilterInput
  $limit: Int
  $nextToken: String
) {
  listMilestones(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      shortName
      name
      description
      scale
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMilestonesQueryVariables,
  APITypes.ListMilestonesQuery
>;
export const getMilestoneNetworkRating = /* GraphQL */ `query GetMilestoneNetworkRating($id: ID!) {
  getMilestoneNetworkRating(id: $id) {
    id
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    networkId
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    milestoneId
    milestone {
      id
      shortName
      name
      description
      scale
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answerOptionId
    answerOption {
      id
      anchor
      sortingIndex
      helpText
      value
      questionId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    milestoneRating
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMilestoneNetworkRatingQueryVariables,
  APITypes.GetMilestoneNetworkRatingQuery
>;
export const listMilestoneNetworkRatings = /* GraphQL */ `query ListMilestoneNetworkRatings(
  $filter: ModelMilestoneNetworkRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  listMilestoneNetworkRatings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      networkId
      network {
        id
        name
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programs {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        acgmeEnabled
        allAttendingHistoryDisabled
        simpl1Id
        categoriesExcludedFromRequestFlow
        dashboardURL
        showDashboardLink
        disableClassicReports
        traineeCanRateTrainee
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      milestoneId
      milestone {
        id
        shortName
        name
        description
        scale
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answerOptionId
      answerOption {
        id
        anchor
        sortingIndex
        helpText
        value
        questionId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      milestoneRating
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMilestoneNetworkRatingsQueryVariables,
  APITypes.ListMilestoneNetworkRatingsQuery
>;
export const getSponsor = /* GraphQL */ `query GetSponsor($id: ID!) {
  getSponsor(id: $id) {
    id
    name
    description
    programs {
      items {
        id
        programID
        sponsorID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    networks {
      items {
        id
        name
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programs {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        acgmeEnabled
        allAttendingHistoryDisabled
        simpl1Id
        categoriesExcludedFromRequestFlow
        dashboardURL
        showDashboardLink
        disableClassicReports
        traineeCanRateTrainee
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    branding {
      colors {
        primary
        secondary
        light
        __typename
      }
      logos {
        fullMono
        fullColor
        squareMono
        squareColor
        email
        __typename
      }
      __typename
    }
    activityLabel
    autoAssignActivities
    dashboardURL
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSponsorQueryVariables,
  APITypes.GetSponsorQuery
>;
export const listSponsors = /* GraphQL */ `query ListSponsors(
  $filter: ModelSponsorFilterInput
  $limit: Int
  $nextToken: String
) {
  listSponsors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSponsorsQueryVariables,
  APITypes.ListSponsorsQuery
>;
export const getAssessment = /* GraphQL */ `query GetAssessment($id: ID!) {
  getAssessment(id: $id) {
    id
    title
    description
    instrumentId
    instrument {
      id
      title
      description
      questions {
        items {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activities {
      items {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      nextToken
      __typename
    }
    multiActivities {
      items {
        id
        assessmentID
        activityID
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDurationHours
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    requireTraineeSelfAssessment
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    published
    archived
    version
    creationDurationHours
    showFeedbackQuestionsToTrainees
    sendEmailForSelfAssessment
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentQueryVariables,
  APITypes.GetAssessmentQuery
>;
export const listAssessments = /* GraphQL */ `query ListAssessments(
  $filter: ModelAssessmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssessments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentsQueryVariables,
  APITypes.ListAssessmentsQuery
>;
export const searchAssessments = /* GraphQL */ `query SearchAssessments(
  $filter: SearchableAssessmentFilterInput
  $sort: [SearchableAssessmentSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableAssessmentAggregationInput]
) {
  searchAssessments(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchAssessmentsQueryVariables,
  APITypes.SearchAssessmentsQuery
>;
export const getInstrument = /* GraphQL */ `query GetInstrument($id: ID!) {
  getInstrument(id: $id) {
    id
    title
    description
    questions {
      items {
        id
        defaultPrompt
        required
        selfAssessmentPrompt
        sortingIndex
        title
        helpText
        inputType
        instrumentId
        answerOptions {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    version
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInstrumentQueryVariables,
  APITypes.GetInstrumentQuery
>;
export const listInstruments = /* GraphQL */ `query ListInstruments(
  $filter: ModelInstrumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listInstruments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      description
      questions {
        items {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInstrumentsQueryVariables,
  APITypes.ListInstrumentsQuery
>;
export const searchInstruments = /* GraphQL */ `query SearchInstruments(
  $filter: SearchableInstrumentFilterInput
  $sort: [SearchableInstrumentSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableInstrumentAggregationInput]
) {
  searchInstruments(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      title
      description
      questions {
        items {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchInstrumentsQueryVariables,
  APITypes.SearchInstrumentsQuery
>;
export const getActivity = /* GraphQL */ `query GetActivity($id: ID!) {
  getActivity(id: $id) {
    id
    title
    description
    subActivities {
      items {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      nextToken
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessments {
      items {
        id
        assessmentID
        activityID
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activityEvents {
      items {
        id
        activityID
        activityEventID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    version
    networks {
      items {
        id
        networkID
        activityID
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    acgmeProcedures {
      items {
        id
        activityID
        acgmeProcedureID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        acgmeProcedure {
          id
          name
          acgmeCode
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    categories
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    activitySubActivitiesId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActivityQueryVariables,
  APITypes.GetActivityQuery
>;
export const listActivities = /* GraphQL */ `query ListActivities(
  $filter: ModelActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  listActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListActivitiesQueryVariables,
  APITypes.ListActivitiesQuery
>;
export const activitiesByAssessment = /* GraphQL */ `query ActivitiesByAssessment(
  $assessmentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  activitiesByAssessment(
    assessmentId: $assessmentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActivitiesByAssessmentQueryVariables,
  APITypes.ActivitiesByAssessmentQuery
>;
export const activitiesBySponsor = /* GraphQL */ `query ActivitiesBySponsor(
  $sponsorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  activitiesBySponsor(
    sponsorId: $sponsorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActivitiesBySponsorQueryVariables,
  APITypes.ActivitiesBySponsorQuery
>;
export const searchActivities = /* GraphQL */ `query SearchActivities(
  $filter: SearchableActivityFilterInput
  $sort: [SearchableActivitySortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableActivityAggregationInput]
) {
  searchActivities(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchActivitiesQueryVariables,
  APITypes.SearchActivitiesQuery
>;
export const getQuestion = /* GraphQL */ `query GetQuestion($id: ID!) {
  getQuestion(id: $id) {
    id
    defaultPrompt
    required
    selfAssessmentPrompt
    sortingIndex
    title
    helpText
    inputType
    instrumentId
    answerOptions {
      items {
        id
        anchor
        sortingIndex
        helpText
        value
        questionId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuestionQueryVariables,
  APITypes.GetQuestionQuery
>;
export const listQuestions = /* GraphQL */ `query ListQuestions(
  $filter: ModelQuestionFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      defaultPrompt
      required
      selfAssessmentPrompt
      sortingIndex
      title
      helpText
      inputType
      instrumentId
      answerOptions {
        items {
          id
          anchor
          sortingIndex
          helpText
          value
          questionId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQuestionsQueryVariables,
  APITypes.ListQuestionsQuery
>;
export const questionsByInstrument = /* GraphQL */ `query QuestionsByInstrument(
  $instrumentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelQuestionFilterInput
  $limit: Int
  $nextToken: String
) {
  questionsByInstrument(
    instrumentId: $instrumentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      defaultPrompt
      required
      selfAssessmentPrompt
      sortingIndex
      title
      helpText
      inputType
      instrumentId
      answerOptions {
        items {
          id
          anchor
          sortingIndex
          helpText
          value
          questionId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.QuestionsByInstrumentQueryVariables,
  APITypes.QuestionsByInstrumentQuery
>;
export const getAnswerOption = /* GraphQL */ `query GetAnswerOption($id: ID!) {
  getAnswerOption(id: $id) {
    id
    anchor
    sortingIndex
    helpText
    value
    questionId
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAnswerOptionQueryVariables,
  APITypes.GetAnswerOptionQuery
>;
export const listAnswerOptions = /* GraphQL */ `query ListAnswerOptions(
  $filter: ModelAnswerOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listAnswerOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      anchor
      sortingIndex
      helpText
      value
      questionId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAnswerOptionsQueryVariables,
  APITypes.ListAnswerOptionsQuery
>;
export const answerOptionsbyQuestion = /* GraphQL */ `query AnswerOptionsbyQuestion(
  $questionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAnswerOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  answerOptionsbyQuestion(
    questionId: $questionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      anchor
      sortingIndex
      helpText
      value
      questionId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AnswerOptionsbyQuestionQueryVariables,
  APITypes.AnswerOptionsbyQuestionQuery
>;
export const getActivityEvent = /* GraphQL */ `query GetActivityEvent($id: ID!) {
  getActivityEvent(id: $id) {
    id
    creatorId
    creator {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    participants {
      items {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activities {
      items {
        id
        activityID
        activityEventID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activityEventDate
    notes
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActivityEventQueryVariables,
  APITypes.GetActivityEventQuery
>;
export const listActivityEvents = /* GraphQL */ `query ListActivityEvents(
  $filter: ModelActivityEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listActivityEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListActivityEventsQueryVariables,
  APITypes.ListActivityEventsQuery
>;
export const activityEventsByCreator = /* GraphQL */ `query ActivityEventsByCreator(
  $creatorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelActivityEventFilterInput
  $limit: Int
  $nextToken: String
) {
  activityEventsByCreator(
    creatorId: $creatorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActivityEventsByCreatorQueryVariables,
  APITypes.ActivityEventsByCreatorQuery
>;
export const searchActivityEvents = /* GraphQL */ `query SearchActivityEvents(
  $filter: SearchableActivityEventFilterInput
  $sort: [SearchableActivityEventSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableActivityEventAggregationInput]
) {
  searchActivityEvents(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchActivityEventsQueryVariables,
  APITypes.SearchActivityEventsQuery
>;
export const getActivityParticipant = /* GraphQL */ `query GetActivityParticipant($id: ID!) {
  getActivityParticipant(id: $id) {
    id
    userId
    user {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    currentPGY
    currentRole
    currentTraineeType
    currentJobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActivityParticipantQueryVariables,
  APITypes.GetActivityParticipantQuery
>;
export const listActivityParticipants = /* GraphQL */ `query ListActivityParticipants(
  $filter: ModelActivityParticipantFilterInput
  $limit: Int
  $nextToken: String
) {
  listActivityParticipants(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListActivityParticipantsQueryVariables,
  APITypes.ListActivityParticipantsQuery
>;
export const participantsByActivityEvent = /* GraphQL */ `query ParticipantsByActivityEvent(
  $activityEventId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelActivityParticipantFilterInput
  $limit: Int
  $nextToken: String
) {
  participantsByActivityEvent(
    activityEventId: $activityEventId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ParticipantsByActivityEventQueryVariables,
  APITypes.ParticipantsByActivityEventQuery
>;
export const getAssessmentEvent = /* GraphQL */ `query GetAssessmentEvent($id: ID!) {
  getAssessmentEvent(id: $id) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentEventQueryVariables,
  APITypes.GetAssessmentEventQuery
>;
export const listAssessmentEvents = /* GraphQL */ `query ListAssessmentEvents(
  $filter: ModelAssessmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssessmentEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentEventsQueryVariables,
  APITypes.ListAssessmentEventsQuery
>;
export const assessmentEventbySubjectUser = /* GraphQL */ `query AssessmentEventbySubjectUser(
  $subjectUserId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  assessmentEventbySubjectUser(
    subjectUserId: $subjectUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssessmentEventbySubjectUserQueryVariables,
  APITypes.AssessmentEventbySubjectUserQuery
>;
export const assessmentEventbyRaterUser = /* GraphQL */ `query AssessmentEventbyRaterUser(
  $raterUserId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  assessmentEventbyRaterUser(
    raterUserId: $raterUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssessmentEventbyRaterUserQueryVariables,
  APITypes.AssessmentEventbyRaterUserQuery
>;
export const assessmentEventsByActivity = /* GraphQL */ `query AssessmentEventsByActivity(
  $activityId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  assessmentEventsByActivity(
    activityId: $activityId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssessmentEventsByActivityQueryVariables,
  APITypes.AssessmentEventsByActivityQuery
>;
export const assessmentEventsByActivityEvent = /* GraphQL */ `query AssessmentEventsByActivityEvent(
  $activityEventId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  assessmentEventsByActivityEvent(
    activityEventId: $activityEventId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssessmentEventsByActivityEventQueryVariables,
  APITypes.AssessmentEventsByActivityEventQuery
>;
export const assessmentEventsByProgram = /* GraphQL */ `query AssessmentEventsByProgram(
  $programId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  assessmentEventsByProgram(
    programId: $programId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssessmentEventsByProgramQueryVariables,
  APITypes.AssessmentEventsByProgramQuery
>;
export const searchAssessmentEvents = /* GraphQL */ `query SearchAssessmentEvents(
  $filter: SearchableAssessmentEventFilterInput
  $sort: [SearchableAssessmentEventSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableAssessmentEventAggregationInput]
) {
  searchAssessmentEvents(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchAssessmentEventsQueryVariables,
  APITypes.SearchAssessmentEventsQuery
>;
export const getAnswerEvent = /* GraphQL */ `query GetAnswerEvent($id: ID!) {
  getAnswerEvent(id: $id) {
    id
    questionId
    question {
      id
      defaultPrompt
      required
      selfAssessmentPrompt
      sortingIndex
      title
      helpText
      inputType
      instrumentId
      answerOptions {
        items {
          id
          anchor
          sortingIndex
          helpText
          value
          questionId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    valueType
    value
    assessmentEventId
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAnswerEventQueryVariables,
  APITypes.GetAnswerEventQuery
>;
export const listAnswerEvents = /* GraphQL */ `query ListAnswerEvents(
  $filter: ModelAnswerEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listAnswerEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      questionId
      question {
        id
        defaultPrompt
        required
        selfAssessmentPrompt
        sortingIndex
        title
        helpText
        inputType
        instrumentId
        answerOptions {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      valueType
      value
      assessmentEventId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAnswerEventsQueryVariables,
  APITypes.ListAnswerEventsQuery
>;
export const answerEventsByAssessmentEvent = /* GraphQL */ `query AnswerEventsByAssessmentEvent(
  $assessmentEventId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAnswerEventFilterInput
  $limit: Int
  $nextToken: String
) {
  answerEventsByAssessmentEvent(
    assessmentEventId: $assessmentEventId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      questionId
      question {
        id
        defaultPrompt
        required
        selfAssessmentPrompt
        sortingIndex
        title
        helpText
        inputType
        instrumentId
        answerOptions {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      valueType
      value
      assessmentEventId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AnswerEventsByAssessmentEventQueryVariables,
  APITypes.AnswerEventsByAssessmentEventQuery
>;
export const searchAnswerEvents = /* GraphQL */ `query SearchAnswerEvents(
  $filter: SearchableAnswerEventFilterInput
  $sort: [SearchableAnswerEventSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableAnswerEventAggregationInput]
) {
  searchAnswerEvents(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      questionId
      question {
        id
        defaultPrompt
        required
        selfAssessmentPrompt
        sortingIndex
        title
        helpText
        inputType
        instrumentId
        answerOptions {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      valueType
      value
      assessmentEventId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchAnswerEventsQueryVariables,
  APITypes.SearchAnswerEventsQuery
>;
export const getAcgmeProcedure = /* GraphQL */ `query GetAcgmeProcedure($id: ID!) {
  getAcgmeProcedure(id: $id) {
    id
    name
    acgmeCode
    activities {
      items {
        id
        activityID
        acgmeProcedureID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        acgmeProcedure {
          id
          name
          acgmeCode
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAcgmeProcedureQueryVariables,
  APITypes.GetAcgmeProcedureQuery
>;
export const listAcgmeProcedures = /* GraphQL */ `query ListAcgmeProcedures(
  $filter: ModelAcgmeProcedureFilterInput
  $limit: Int
  $nextToken: String
) {
  listAcgmeProcedures(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      acgmeCode
      activities {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAcgmeProceduresQueryVariables,
  APITypes.ListAcgmeProceduresQuery
>;
export const getProgramSponsors = /* GraphQL */ `query GetProgramSponsors($id: ID!) {
  getProgramSponsors(id: $id) {
    id
    programID
    sponsorID
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProgramSponsorsQueryVariables,
  APITypes.GetProgramSponsorsQuery
>;
export const listProgramSponsors = /* GraphQL */ `query ListProgramSponsors(
  $filter: ModelProgramSponsorsFilterInput
  $limit: Int
  $nextToken: String
) {
  listProgramSponsors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      programID
      sponsorID
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProgramSponsorsQueryVariables,
  APITypes.ListProgramSponsorsQuery
>;
export const getNetworkProgram = /* GraphQL */ `query GetNetworkProgram($id: ID!) {
  getNetworkProgram(id: $id) {
    id
    programID
    networkID
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNetworkProgramQueryVariables,
  APITypes.GetNetworkProgramQuery
>;
export const listNetworkPrograms = /* GraphQL */ `query ListNetworkPrograms(
  $filter: ModelNetworkProgramFilterInput
  $limit: Int
  $nextToken: String
) {
  listNetworkPrograms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      programID
      networkID
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      network {
        id
        name
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programs {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        acgmeEnabled
        allAttendingHistoryDisabled
        simpl1Id
        categoriesExcludedFromRequestFlow
        dashboardURL
        showDashboardLink
        disableClassicReports
        traineeCanRateTrainee
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNetworkProgramsQueryVariables,
  APITypes.ListNetworkProgramsQuery
>;
export const getNetworkActivity = /* GraphQL */ `query GetNetworkActivity($id: ID!) {
  getNetworkActivity(id: $id) {
    id
    networkID
    activityID
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNetworkActivityQueryVariables,
  APITypes.GetNetworkActivityQuery
>;
export const listNetworkActivities = /* GraphQL */ `query ListNetworkActivities(
  $filter: ModelNetworkActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  listNetworkActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      networkID
      activityID
      network {
        id
        name
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programs {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        acgmeEnabled
        allAttendingHistoryDisabled
        simpl1Id
        categoriesExcludedFromRequestFlow
        dashboardURL
        showDashboardLink
        disableClassicReports
        traineeCanRateTrainee
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNetworkActivitiesQueryVariables,
  APITypes.ListNetworkActivitiesQuery
>;
export const getAssessmentActivity = /* GraphQL */ `query GetAssessmentActivity($id: ID!) {
  getAssessmentActivity(id: $id) {
    id
    assessmentID
    activityID
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentActivityQueryVariables,
  APITypes.GetAssessmentActivityQuery
>;
export const listAssessmentActivities = /* GraphQL */ `query ListAssessmentActivities(
  $filter: ModelAssessmentActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssessmentActivities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      assessmentID
      activityID
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentActivitiesQueryVariables,
  APITypes.ListAssessmentActivitiesQuery
>;
export const getActivityEventActivities = /* GraphQL */ `query GetActivityEventActivities($id: ID!) {
  getActivityEventActivities(id: $id) {
    id
    activityID
    activityEventID
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActivityEventActivitiesQueryVariables,
  APITypes.GetActivityEventActivitiesQuery
>;
export const listActivityEventActivities = /* GraphQL */ `query ListActivityEventActivities(
  $filter: ModelActivityEventActivitiesFilterInput
  $limit: Int
  $nextToken: String
) {
  listActivityEventActivities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      activityID
      activityEventID
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListActivityEventActivitiesQueryVariables,
  APITypes.ListActivityEventActivitiesQuery
>;
export const getAcgmeProcedureActivity = /* GraphQL */ `query GetAcgmeProcedureActivity($id: ID!) {
  getAcgmeProcedureActivity(id: $id) {
    id
    activityID
    acgmeProcedureID
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    acgmeProcedure {
      id
      name
      acgmeCode
      activities {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAcgmeProcedureActivityQueryVariables,
  APITypes.GetAcgmeProcedureActivityQuery
>;
export const listAcgmeProcedureActivities = /* GraphQL */ `query ListAcgmeProcedureActivities(
  $filter: ModelAcgmeProcedureActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  listAcgmeProcedureActivities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      activityID
      acgmeProcedureID
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      acgmeProcedure {
        id
        name
        acgmeCode
        activities {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAcgmeProcedureActivitiesQueryVariables,
  APITypes.ListAcgmeProcedureActivitiesQuery
>;
export const appVersions = /* GraphQL */ `query AppVersions {
  appVersions {
    iosRequired
    iosRecommended
    androidRequired
    androidRecommended
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppVersionsQueryVariables,
  APITypes.AppVersionsQuery
>;
